<template>
  <div>
    <Loader v-if="initalLoad" class="loader" />
    <SmFilter
      v-else
      :selectCounter="selectCounter"
      :clearble="!isDefault"
      @clear="resetFilters"
    >
      <div class="appointment-filter">
        <div class="appointment-filter--up">
          <ClinicFilter
            v-model="clinicSelected"
            :items="clinicList"
            :clearble="defaultState['clinicIds']"
            @submit="() => submitHandler('clinicIds', clinicSelected)"
            @reset-filter="() => resetFilter('clinicIds')"
          />
          <DateFilter
            v-model="dateSelected"
            :availableDates="availableDates"
            :disablePrev="true"
            title="Дата приёма"
            @to-page="toPage"
            @moveMonth="moveMonthHandler"
            @submit="() => submitHandler('dates', dateSelected)"
            @reset-filter="() => resetFilter('dates')"
          />
          <SelectFilter
            v-model="degreeSelected"
            class="degree"
            title="Квалификация, степень"
            :items="degreeList"
          />
        </div>
        <div class="appointment-filter--down">
          <DoctorFilter
            v-model="doctorSelected"
            :items="doctorList"
            :clearble="defaultState['doctorIds']"
            @submit="() => submitHandler('doctorIds', doctorSelected)"
            @reset-filter="() => resetFilter('doctorIds')"
          />
          <RadioFilter
            v-model="genderSelected"
            :items="genderList"
            @submit="() => submitHandler('gender', genderSelected)"
          />
        </div>
      </div>
    </SmFilter>
  </div>
</template>
<script>
import {
  eachDayOfInterval,
  startOfMonth,
  endOfMonth,
  format,
  parse
} from 'date-fns'

import { onMounted, ref, toRefs, watch } from '@vue/composition-api'
import { useStore } from '@/store'
import { useDisplay } from '@/hooks'

import { SmFilter } from '@/components/smFilters/components'
import Loader from '@/components/loader'

import {
  ClinicFilter,
  DateFilter,
  DoctorFilter,
  RadioFilter,
  SelectFilter
} from '../components'
import { mergeUniqueArrays } from '@/core/helpers'
import { omitByNull } from '@/core/utils'
import useFilter from '../hooks/useFilter'

export default {
  name: 'AppointmentFilter',
  components: {
    ClinicFilter,
    DateFilter,
    RadioFilter,
    SmFilter,
    SelectFilter,
    DoctorFilter,
    Loader
  },
  props: ['initState'],
  setup(props, ctx) {
    const { initState } = toRefs(props)
    const display = useDisplay()
    const store = useStore()

    const initalLoad = ref(true)
    const isDefault = ref(true)
    const selectCounter = ref(0)
    const defaultState = ref({})
    const availableDates = ref([])

    const degreeList = ref([])
    const degreeSelected = ref([])

    const clinicList = ref([])
    const clinicSelected = ref([])

    const doctorList = ref([])
    const doctorSelected = ref([])

    const genderList = ['Любой', 'Мужской', 'Женский']
    const genderSelected = ref(initGender())

    const dateSelected = ref(null)

    watch(genderSelected, () => {
      if (display.value.smAndDown) return
      submitHandler('gender', genderSelected.value)
    })

    function initGender() {
      if (initState.value.doctorSex === 'MALE') return 'Мужской'
      if (initState.value.doctorSex === 'FEMALE') return 'Женский'
      return 'Любой'
    }

    // const submitHandler = {
    //   doctor: () => {
    //     ctx.emit('submit', {
    //       id: 'doctorIds',
    //       value: doctorSelected.value
    //     })
    //   },
    //   clinic: () => {
    //     ctx.emit('submit', {
    //       id: 'clinicIds',
    //       value: clinicSelected.value
    //     })
    //   },
    //   date: () => {
    //     ctx.emit('submit', {
    //       id: 'dates',
    //       value: dateSelected.value
    //     })
    //   },
    //   gender: () => {
    //     let value = null

    //     if (genderSelected.value === 'Мужской') {
    //       value = 'MALE'
    //     }
    //     if (genderSelected.value === 'Женский') {
    //       value = 'FEMALE'
    //     }

    //     ctx.emit('submit', {
    //       id: 'doctorSex',
    //       value
    //     })
    //   }
    // }

    function submitHandler(id, value) {
      switch (id) {
        case 'dates':
          ctx.emit('submit', { id, value })
          break
        case 'gender': {
          let result = null

          if (value === 'Мужской') {
            result = 'MALE'
          }

          if (value === 'Женский') {
            result = 'FEMALE'
          }

          ctx.emit('submit', {
            id: 'doctorSex',
            value: result
          })
          break
        }
        default:
          ctx.emit('submit', { id, value: value.map((v) => v.id) })
      }
    }

    function resetFilter(type) {
      ctx.emit('reset', type)
    }

    function resetFilters() {
      ctx.emit('reset-all-filters')
    }

    async function toPage({ year, month }) {
      const formattedMonth = month < 10 ? `0${month}` : month
      const dateStr = `${year}-${formattedMonth}`
      const parsedDate = parse(dateStr, 'yyyy-MM', new Date())
      const daysInMonth = eachDayOfInterval({
        start: parsedDate,
        end: endOfMonth(parsedDate)
      }).length

      const date = {
        month,
        year,
        days: daysInMonth
      }

      await moveMonthHandler({ date })
    }

    async function moveMonthHandler({ date }) {
      const time = `${date.year}-${
        date.month < 10 ? `0${date.month}` : date.month
      }-`

      const payload = {
        specialityIds: [ctx.root.$route.params.specId],
        doctorIds: initState.value.doctorIds,
        clinicIds: initState.value.clinicIds,
        dates: initState.value.dates,
        from: time + '01T00:00:00.000Z',
        to: time + `${date.days}T23:59:59.999Z`,
        doctorSex: initState.value.doctorSex
      }

      await store.dispatch('timeslots/getAvailableDates', payload)
      availableDates.value = store.getters['timeslots/availableDates']
    }

    onMounted(async () => {
      const payload = omitByNull({
        specialityIds: [ctx.root.$route.params.specId],
        doctorIds: initState.value.doctorIds,
        clinicIds: initState.value.clinicIds,
        dates: initState.value.dates,
        from: initState.value.from,
        to: initState.value.to,
        doctorSex: initState.value.doctorSex
      })

      await store.dispatch('timeslots/getDoctorsFilter', payload)
      await store.dispatch('timeslots/getAvailableDates', {
        ...payload,
        from: `${format(startOfMonth(new Date()), 'yyyy-MM-dd')}T00:00:00.000Z`,
        to: `${format(endOfMonth(new Date()), 'yyyy-MM-dd')}T23:59:59.999Z`,
        specialityIds: [ctx.root.$route.params.specId]
      })

      const filterConfig = [
        {
          id: 'clinicIds',
          initial: initState.value.clinicIds,
          list: store.getters['timeslots/clinicsFilters']
        },
        // {
        //   id: 'specialityIds',
        //   initial: initState.value.specialityIds,
        //   list: store.getters['visits/visitsFilterData'].specialities
        // },
        {
          id: 'doctorIds',
          initial: initState.value.doctorIds,
          list: store.getters['timeslots/doctorsFilters']
        }
      ]

      const {
        list,
        selected,
        isDefault: _isDefault,
        selectCounter: _selectCounter,
        defaultState: _defaultState
      } = useFilter(filterConfig)

      availableDates.value = store.getters['timeslots/availableDates']

      clinicList.value = list['clinicIds']
      clinicSelected.value = selected['clinicIds']

      doctorList.value = list['doctorIds']
      doctorSelected.value = selected['doctorIds']

      isDefault.value = _isDefault
      selectCounter.value = _selectCounter
      defaultState.value = _defaultState

      const filterInitState = store.getters['filter/getInitState']
      let filterStash = null

      if (!filterInitState?.timeslots) {
        const timeslots = {
          clinicList: clinicList.value,
          doctorList: doctorList.value
        }
        store.commit('filter/setInitState', { timeslots })
        filterStash = store.getters['filter/getInitState']
      } else {
        filterStash = filterInitState.timeslots
      }

      if (initState.value.clinicIds) {
        if (!initState.value.doctorIds && clinicList.value.length) {
          clinicList.value = mergeUniqueArrays(
            clinicList.value,
            filterStash.clinicList,
            'id'
          )
        }
      }

      if (initState.value.doctorIds) {
        if (!initState.value.clinicIds && doctorList.value.length) {
          doctorList.value = mergeUniqueArrays(
            doctorList.value,
            filterStash.doctorList,
            'id'
          )
        }
      }

      if (initState.value.dates) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'mulitiple',
          value: initState.value.dates
        }
      }

      if (initState.value.from && initState.value.to) {
        isDefault.value = false
        selectCounter.value++
        dateSelected.value = {
          calendarMode: 'range',
          value: {
            start: initState.value.from,
            end: initState.value.to
          }
        }
      }

      if (initState.value.doctorSex) {
        isDefault.value = false
      }

      initalLoad.value = false

      // const doctorsFilters = store.getters['timeslots/doctorsFilters']
      // const clinicsFilters = store.getters['timeslots/clinicsFilters']

      // const filterInitState = store.getters['filter/getInitState']

      // let filterStash = null

      // if (!filterInitState) {
      //   store.commit('filter/setInitState', { doctorsFilters, clinicsFilters })
      //   filterStash = store.getters['filter/getInitState']
      // } else {
      //   filterStash = filterInitState
      // }

      // if (doctorsFilters.length) {
      //   for (const doctor of doctorsFilters) {
      //     doctorList.value.push({
      //       id: doctor.id,
      //       name: doctor.name,
      //       icon: doctor.photo,
      //       totalExperience: doctor.totalExperience
      //     })
      //   }
      // }

      // if (initState.value.doctorIds) {
      //   defaultState.value.doctor = true
      //   for (const doctorId of initState.value.doctorIds) {
      //     const findDoctor = doctorList.value.find((v) => v.id === doctorId)
      //     if (!findDoctor) continue

      //     doctorSelected.value.push(findDoctor)
      //   }

      //   if (!initState.value.clinicIds && doctorList.value.length) {
      //     doctorList.value = mergeUniqueArrays(
      //       doctorList.value,
      //       filterStash.doctorsFilters,
      //       'id'
      //     )
      //   }
      // } else {
      //   doctorSelected.value = doctorList.value
      // }

      // if (clinicsFilters.length) {
      //   for (const clinic of clinicsFilters) {
      //     clinicList.value.push(clinic)
      //   }
      // }

      // if (initState.value.clinicIds) {
      //   defaultState.value.clinic = true
      //   for (const clinicId of initState.value.clinicIds) {
      //     const findClinic = clinicList.value.find((v) => v.id === clinicId)
      //     if (!findClinic) continue

      //     clinicSelected.value.push(findClinic)
      //   }

      //   if (!initState.value.doctorIds && clinicList.value.length) {
      //     clinicList.value = mergeUniqueArrays(
      //       clinicList.value,
      //       filterStash.clinicsFilters,
      //       'id'
      //     )
      //   }
      // } else {
      //   clinicSelected.value = clinicList.value
      // }

      // if (initState.value.dates) {
      //   defaultState.value.date = true
      //   dateSelected.value = {
      //     calendarMode: 'mulitiple',
      //     value: initState.value.dates
      //   }
      // }

      // if (initState.value.from && initState.value.to) {
      //   defaultState.value.date = true
      //   dateSelected.value = {
      //     calendarMode: 'range',
      //     value: {
      //       start: initState.value.from,
      //       end: initState.value.to
      //     }
      //   }
      // }

      // for (const key in defaultState.value) {
      //   if (defaultState.value[key]) selectCounter.value += 1
      // }

      // initalLoad.value = false
    })

    return {
      doctorList,
      degreeList,
      clinicList,
      genderList,
      doctorSelected,
      degreeSelected,
      clinicSelected,
      genderSelected,
      dateSelected,
      isDefault,
      defaultState,
      selectCounter,
      availableDates,
      moveMonthHandler,
      submitHandler,
      resetFilters,
      resetFilter,
      toPage,
      display,
      initalLoad
    }
  }
}
</script>
<style lang="scss" scoped>
@import 'style';
</style>
